// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "fc505061c56ada79a19d3f6ad53373bd47aad2c5/static/css/" + chunkId + "." + {"252":"3d0d1673","679":"8a24132f","725":"84c1fc5e"}[chunkId] + ".chunk.css";
};